import type * as store from '@attain-apps/fe/web/main/lib/store'

export const FEATURE: store.Feature.Parent = {
  name: 'display',
}
